import React, { PureComponent } from 'react';
import { string, arrayOf, object, func, number, bool } from 'prop-types';
import compose from 'lodash/flowRight';
import { connectRefinementList } from 'react-instantsearch-core';
import { withFeatureFlags } from 'connectors';
import FilterCollapsePanel from '../FilterCollapsePanel/FilterCollapsePanel';
import CommonRefinementList from './CommonRefinementList/CommonRefinementList';
import './RefinementList.scss';

class RefinementList extends PureComponent {
    static propTypes = {
        className: string,
        currentRefinement: arrayOf(string).isRequired,
        mobileWidth: number.isRequired,
        refine: func.isRequired,
        label: string.isRequired,
        style: object, // eslint-disable-line react/forbid-prop-types
        attribute: string.isRequired,
        openedByDefault: bool,
        onFilterSelected: func.isRequired,
        hasSearchInSpecificFilters: bool,
    };

    static defaultProps = {
        className: null,
        openedByDefault: true,
        hasSearchInSpecificFilters: true,
        style: {},
    };

    doRefine = (value, filterQuery) => {
        const { currentRefinement, refine, onFilterSelected } = this.props;

        const valueIndex = currentRefinement.indexOf(value);
        let values = [...currentRefinement];

        if (valueIndex === -1) {
            values.push(value);
            onFilterSelected({ value, filterQuery });
        } else {
            values = values.filter(val => val !== value);
        }

        refine(values);
    };

    render() {
        const {
            className,
            label,
            style,
            currentRefinement,
            mobileWidth,
            attribute,
            openedByDefault,
            hasSearchInSpecificFilters,
            ...otherProps
        } = this.props;

        const isSpecificFilters = this.props.attribute.startsWith(
            'catalog_attribute.',
        );
        return (
            <FilterCollapsePanel
                className={className}
                label={label}
                dataQa={attribute}
                openedByDefault={openedByDefault}
            >
                <div className="refinementList-items">
                    <CommonRefinementList
                        onSelectItem={this.doRefine}
                        label={label}
                        isSearchable={
                            isSpecificFilters
                                ? hasSearchInSpecificFilters
                                : true
                        }
                        attribute={attribute}
                        inputSearchClassName="refinement-searchInput"
                        {...otherProps}
                    />
                </div>
            </FilterCollapsePanel>
        );
    }
}

export default compose(
    withFeatureFlags({
        mobileWidth: 'instantSearch.mobileWidth',
        hasSearchInSpecificFilters:
            'browsing.listing.search.in.specific.filters',
    }),
    connectRefinementList,
)(RefinementList);
